import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/navigation';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl text-white"></i>
                </div>
                <span className="text-xl font-bold font-heading text-white">
                  桔子视频
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                收录91视频网站、久久视频等热门视频资源，91在线视频高清免费在线观看，菠萝视频同步更新，电视剧全集电影大全流畅不缓冲。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">帮助中心</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.help.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.partner.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                      rel="nofollow"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 桔子视频 JuziShipin.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}